export default "__VITE_ASSET__DlXojGS3__"